import { CalendarDays, Video, Users, Sparkles } from "lucide-react";

const steps = [
  {
    icon: CalendarDays,
    title: "Välj en träff",
    text: "Se kalendern och välj ett datum som passar.",
  },
  {
    icon: Video,
    title: "Delta via Zoom",
    text: "Klicka på Zoomlänken när det är dags. Du behöver inte anmäla dig separat till träffen.",
  },
  {
    icon: Users,
    title: "Lär känna andra i mindre grupper",
    text: "Presentera dig kort, berätta gärna vad du skulle vilja ha hjälp med och låt samtalet ta vid.",
  },
];


const HowItWorks = () => {
  return (
    <section className="py-20 px-4 bg-secondary/40">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full mb-4 text-sm font-medium">
            <Sparkles className="h-4 w-4" />
            Så fungerar det
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Tre enkla steg till nya samtal
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Ett tryggt format som gör det enkelt att komma igång.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div
              key={step.title}
              className="group text-center p-8 rounded-2xl bg-card hover:bg-primary transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-accent text-white mb-5 group-hover:scale-110 transition-transform">
                <step.icon className="h-7 w-7" />
              </div>
              <h3 className="text-xl font-bold text-primary group-hover:text-white mb-3 transition-colors">
                {step.title}
              </h3>
              <p className="text-muted-foreground group-hover:text-white/80 leading-relaxed transition-colors">
                {step.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-2xl mx-auto rounded-2xl border border-border bg-card p-6 text-center">
          <p className="font-semibold text-primary mb-1">Vill du inte missa nästa träff?</p>
          <p className="text-muted-foreground">
            Anmäl dig till utskickslistan så får du information och påminnelser om kommande
            träffar.
          </p>
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
